import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Activity,
  Leaf,
  Sparkles,
  Wind,
  ShieldCheck,
  Users,
  Award,
  ArrowRight,
  Phone,
  Zap,
  HeartHandshake,
  BrainCircuit,
  HeartPulse,
  Stethoscope,
} from "lucide-react";
// import img from "../assets/images/img34.png"
// import img1 from "../assets/images/img31.png"
// import img2 from "../assets/images/img32.png"
// import img3 from "../assets/images/img33.png"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation, Autoplay } from "swiper/modules";
import Categoriespage from "./categories/Categoriespage";
import categoryAPI from "../api/categoryApi";

const treatments = [
  {
    title: "Joint & Back Pain",
    icon: <Activity />,
    desc: "Natural way to reduce swelling and get your movement back without surgery.",
    img: "../../images/img31.png",
  },
  {
    title: "Stomach Issues",
    icon: <Leaf />,
    desc: "Get rid of gas, acidity, and bloating using simple herbal detox.",
    img: "../../images/img32.png",
  },
  {
    title: "Skin & Hair Care",
    icon: <Sparkles />,
    desc: "Clear skin and healthy hair using pure oils and blood-purifying herbs.",
    img: "../../images/img33.png",
  },
  {
    title: "Stress & Mind",
    icon: <Wind />,
    desc: "Relax your brain and get better sleep with our traditional oil therapies.",
    img: "https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=400",
  },
];

const doctors = [
  {
    id: 1,
    name: "Dr. Vinay Kumar",
    specialties:
      "Sugar, BP, Thyroid,Joint Pain, Skin Problems, Kidney Stones,Gynae Problems ",
    // experience: "5 years of experience",
    image: "../../images/doctor.jpeg",
    bgColor: "#22a05a",
  },
  {
    id: 2,
    name: "Dr. Rajkumar Moun",
    specialties:
      "Sugar, BP, Thyroid,Joint Pain, Skin Problems, Cancer, Kidney Stones ",
    // experience: "10 years of experience",
    image: "../../images/doctor1.jpeg",
    bgColor: "#f0f0f0",
  },
];

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.3 },
  },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const Clinic = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing();

      if (res.code === 200) {
        const { items, totalCount } = res.data;

        setItems(items);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="ayurveda-page">
        {/* --- HERO SECTION --- */}
        <section className="clinic-hero-v3">
          <div className="container">
            <div className="row align-items-center py-5">
              <div className="col-lg-6">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  {/* <span className="badge-simple">Welcome to Our Clinic</span> */}
                  {/* <h1 className="hero-title-v3">The Best Integrated Clinic in Kaithal</h1> */}
                  <div className="first-header">
                    <h2>
                      The Best Integrated Raj Ayurveda Clinic in VPO Kithana,
                      District  Kaithal
                    </h2>
                  </div>
                  <p className="hero-p-v3">
                  <strong>Top Trend Ayurveda A Group of Sun Rise Pharma</strong>  एक विश्वसनीय और अग्रणी आयुर्वेदिक ब्रांड है, जो प्राकृतिक उपचार और संपूर्ण स्वास्थ्य को बढ़ावा देने के लिए समर्पित है। हमारा उद्देश्य आयुर्वेद की प्राचीन और प्रभावशाली ज्ञान परंपरा को आधुनिक जीवनशैली के साथ जोड़ना है, ताकि हर व्यक्ति एक स्वस्थ, संतुलित और खुशहाल जीवन जी सके।

हम उच्च गुणवत्ता वाले, शुद्ध और प्रमाणिक आयुर्वेदिक उत्पाद प्रदान करते हैं, जिन्हें विशेषज्ञों की देखरेख में सावधानीपूर्वक तैयार किया जाता है। हमारा मानना है कि प्रकृति में ही बेहतर स्वास्थ्य और दीर्घायु का रहस्य छिपा है, इसलिए हम प्राकृतिक जड़ी-बूटियों और पारंपरिक विधियों का उपयोग करते हैं।

Top Trend Ayurvedic में हम अपने ग्राहकों को सुरक्षित, प्रभावी और भरोसेमंद स्वास्थ्य समाधान प्रदान करने के लिए प्रतिबद्ध हैं, जिससे वे अपने जीवन में संतुलन और ऊर्जा बनाए रख सकें।
                  </p>
                  <p className="hero-p-v3">
                    Welcome to <strong>Top Trend Ayurveda A Group of Sun Rise Pharma</strong> your premier destination for
                    holistic wellness and traditional healing. Founded with a
                    vision to bring the timeless wisdom of Ayurveda into the
                    modern lifestyle, our company stands as a beacon of purity
                    and health. We are dedicated to providing high-quality,
                    authentic Ayurvedic products that help you achieve a
                    balanced and harmonious life through natural means. At Top
                    Trend Ayurvedic, we believe that nature holds the key to
                    optimal health and longevity. Our operations are guided by
                    deep clinical expertise and a commitment to the science of
                    life, ensuring that every product we offer is crafted with
                    care and precision. Our primary center is located at Raj
                    Nursing Home, VPO Kithana, District Sonipat, Haryana,
                    serving our valued customers from our base in Kaithal,
                    Haryana 136044. By combining ancient herbal formulations
                    with contemporary quality standards, we ensure that you
                    receive safe and effective wellness solutions.
                  </p>
                  {/* <div className="d-flex flex-wrap gap-3 mt-4">
                  <button className="btn-main">Book Your Visit</button>
                  <button className="btn-call"><Phone size={18} className="me-2"/> Call Us Now</button>
                </div> */}
                </motion.div>
              </div>
              <div className="col-lg-6 mt-4 mt-lg-0">
                <div className="hero-img-simple">
                  <img
                    src="../../images/img34.png"
                    alt="Doctor Consultation"
                    className="custom-clinic-image"
                  />
                  {/* <div className="experience-tag"><b>15+ Years</b> of Trust</div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- TREATMENTS --- */}
        {/* <section className="treatments-v3 py-5">
          <div className="container">
            <div className="section-head-v3 mb-5">
              <h2>What We Treat</h2>
             
            </div>
            <div className="row g-4">
              {treatments.map((t, idx) => (
                <div className="col-md-6 col-lg-3" key={idx}>
                  <div className="simple-card">
                    <div className="card-top">
                      <img src={t.img} alt={t.title} />
                      <div className="icon-circle">{t.icon}</div>
                    </div>
                    <div className="card-body-v3 text-center">
                      <h4>{t.title}</h4>
                      <p>{t.desc}</p>
                      
                      <a
                        href="https://wa.me/9017532000?text=Hi%20I%20need%20help"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ax-whatsapp-btn"
                      >
                       
                        <span>Connect to WhatsApp</span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        <section className="py-5">
          <div className="container">
            {/* Heading */}
            <div className="mb-5 text-center">
              <h2>What We Treat</h2>
            </div>

            {/* Swiper */}
            {items && items.length > 0 && (
              <Swiper
                modules={[Pagination, Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={3}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={true}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 1.5 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
              >
                {items.map((item, index) => (
                  <SwiperSlide key={index}>
                    {/* 👇 Your SAME component */}
                    <Categoriespage item={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </section>

        {/* --- WHY US --- */}
        <section className="why-us-v3 py-5">
          <div className="container">
            <div className="row g-4 text-center">
              <div className="col-md-4">
                <div className="trust-item">
                  <ShieldCheck size={40} className="mb-3" />
                  <h5>No Side Effects</h5>
                  <p>Our medicines are 100% natural and safe for all ages.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="trust-item">
                  <Users size={40} className="mb-3 " />
                  <h5>Expert Doctors</h5>
                  <p>
                    Our team has years of experience in traditional healing.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="trust-item">
                  <Award size={40} className="mb-3 " />
                  <h5>Real Results</h5>
                  <p>Over 12,000+ patients have recovered with us.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="doctors-section">
          <div className="container">
            {/* Header */}
            <div className="header">
              {/* <p className="sub-title">Meet Our Expert Doctors</p> */}
              <h2>Your Health, Our Priority</h2>
              {/* <div className="line"></div> */}
            </div>

            {/* Cards */}
            <div className="grid">
              {doctors.map((doctor, index) => (
                <div
                  key={doctor.id}
                  className={`doctor-card ${hoveredIndex === index ? "hovered" : ""}`}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <div className="doctor-img-wrapper">
                    <img
                      src={doctor.image}
                      alt={doctor.name}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentNode.style.background = doctor.bgColor;
                      }}
                    />

                    <div className="overlay-gradient"></div>

                    <div
                      className={`doctor-info ${hoveredIndex === index ? "active" : ""}`}
                    >
                      <h3>{doctor.name}</h3>
                      <p>{doctor.specialties}</p>

                      <div className="experience">
                        {/* <span className="dot"></span> */}
                        <span>{doctor.experience}</span>
                      </div>

                      {/* <button className="book-btn">
                    Book Appointment
                  </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            {/* <div className="cta">
          <button className="view-btn">View All Doctors</button>
        </div> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default Clinic;
